module.exports = __webpack_public_path__ + "media/images/icons/outlined/delete-column-5068ba7ed8186dc52240f808fc3a40a2.svg";